import { apiBase } from "./base";

const apiSmetNorms = {
	client: apiBase.get_client(),
	url: "/smetnorms/",

	getSsrWorkTypes() {
		return this.client.get(this.url + "summary_estm_work_types/", apiBase.get_headers());
	},

	getSsrCalcsTypes() {
		return this.client.get(this.url + "summary_estm_calcs_types/", apiBase.get_headers());
	},

	getSsrCalcsBook() {
		return this.client.get(this.url + "summary_estm_calcs_book/", apiBase.get_headers());
	},
};

export default apiSmetNorms;
